'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { BlogPostDto, BlogTagDto } from '@/components/BlogPage/types';
import { getRelevantBlogPosts } from '@/lib/blog';
import { RELEVANT_BLOG_POSTS_PAGE_SIZE } from '@/lib/blog/const';
interface UseRelevantBlogPostsParams {
  tags?: BlogTagDto[];
  currentPostId?: number;
}
export const useRelevantBlogPosts = t0 => {
  const $ = _c(20);
  const {
    tags,
    currentPostId
  } = t0 === undefined ? {} : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [allPosts, setAllPosts] = useState(t1);
  const [visibleCount, setVisibleCount] = useState(RELEVANT_BLOG_POSTS_PAGE_SIZE);
  const [hasMoreFromTags, setHasMoreFromTags] = useState(false);
  const tagIdsKey = tags?.map(_temp).join(",") ?? "";
  let t2;
  if ($[1] !== setVisibleCount) {
    t2 = () => setVisibleCount(_temp2);
    $[1] = setVisibleCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const showMore = t2;
  let t3;
  if ($[3] !== currentPostId || $[4] !== setAllPosts || $[5] !== setHasMoreFromTags || $[6] !== setVisibleCount || $[7] !== tagIdsKey) {
    t3 = () => {
      let cancelled = false;
      const tagIds = tagIdsKey ? tagIdsKey.split(",").map(Number) : [];
      const fetchPosts = async () => {
        setVisibleCount(RELEVANT_BLOG_POSTS_PAGE_SIZE);
        const {
          posts,
          hasMoreFromTags: nextHasMoreFromTags
        } = await getRelevantBlogPosts({
          tagIds,
          currentPostId
        });
        if (!cancelled) {
          setAllPosts(posts);
          setHasMoreFromTags(nextHasMoreFromTags);
        }
      };
      fetchPosts();
      return () => {
        cancelled = true;
      };
    };
    $[3] = currentPostId;
    $[4] = setAllPosts;
    $[5] = setHasMoreFromTags;
    $[6] = setVisibleCount;
    $[7] = tagIdsKey;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== currentPostId || $[10] !== tagIdsKey) {
    t4 = [tagIdsKey, currentPostId];
    $[9] = currentPostId;
    $[10] = tagIdsKey;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  useEffect(t3, t4);
  let t5;
  if ($[12] !== allPosts || $[13] !== hasMoreFromTags || $[14] !== visibleCount) {
    t5 = hasMoreFromTags ? allPosts.slice(0, visibleCount) : allPosts;
    $[12] = allPosts;
    $[13] = hasMoreFromTags;
    $[14] = visibleCount;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const posts_0 = t5;
  const t6 = hasMoreFromTags && visibleCount < allPosts.length;
  let t7;
  if ($[16] !== posts_0 || $[17] !== showMore || $[18] !== t6) {
    t7 = {
      posts: posts_0,
      hasMore: t6,
      showMore
    };
    $[16] = posts_0;
    $[17] = showMore;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
function _temp(tag) {
  return tag.id;
}
function _temp2(count) {
  return count + RELEVANT_BLOG_POSTS_PAGE_SIZE;
}